// Basically a copy of 'Teselagen.utils.NameUtils' for use within workers.

module.exports = {
	/**
	 * Reformat name to replaces whitespace with underscores.
	 * @param {String} pName
	 * @returns {String} New name.
	 */
	reformatName: function(pName) {
		return pName.toString().replace(/ /g, '_');
	},
};




// WEBPACK FOOTER //
// ./src/utils/NameUtils.js